import { takeLatest, put, call } from 'redux-saga/effects'
import { getRequest } from '../../../../utils/User/axios'
import {
  getPesticidesRequest, getPesticidesSuccess, getPesticidesFailed,
  getPesticideFilterRequest, getPesticideFilterFailed, getPesticideFilterSuccess,
} from '../Reducer'

export default function* getPesticidesWatcherSage() {
  yield takeLatest(getPesticidesRequest.type, getPesticidesSaga)
  yield takeLatest(getPesticideFilterRequest.type, getPesticideFilterSaga)
}

const getPesticides = () => getRequest(`${ process.env.REACT_APP_URL }/all-pesticide`)

const getFilteredPesticides = ({ text }) => getRequest(`${ process.env.REACT_APP_URL }/filter-pesticide?text=${ text }`)

function* getPesticidesSaga() {
  try {
    const response = yield call(getPesticides)
    yield put(getPesticidesSuccess(response.data))
  } catch (error) {
    yield put(getPesticidesFailed(error))
  }
}

function* getPesticideFilterSaga({ payload }) {
  try {
    const response = yield call(getFilteredPesticides, payload)
    yield put(getPesticideFilterSuccess(response.data))
  } catch (error) {
    yield put(getPesticideFilterFailed(error))
  }
}
